import React from 'react';
import PropTypes from 'prop-types';

import ReportIcon from '@material-ui/icons/ReportProblemOutlined';
import BaseDialog from '../BaseDialog/BaseDialog';

import { getString } from '../../helpers/stringHelpers.js';
import ReplaceContact from '../../components/Replace/ReplaceContact/ReplaceContact';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class ConfirmTenantDialog extends React.Component {
  render() {
    const { classes, show, ok, cancel, toggleContactModal, buttonCustomClass } =
      this.props;

    const stringsComponent = 'confirmTenantDialog';

    return !show ? null : (
      <div>
        <BaseDialog
          open={show}
          content={
            <ReplaceContact
              content={getString(stringsComponent, 'MESSAGE')}
              action={toggleContactModal}
              isLink={true}
            />
          }
          buttonAction={ok}
          buttonLabel={getString(stringsComponent, 'BUTTON_LABEL_CONFIRM')}
          secondaryButtonAction={cancel}
          secondaryButtonLabel={getString(
            stringsComponent,
            'BUTTON_LABEL_CANCEL'
          )}
          icon={ReportIcon}
          buttonCustomClass={buttonCustomClass}
        />
      </div>
    );
  }
}

ConfirmTenantDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  show: PropTypes.bool,
  buttonCustomClass: PropTypes.string,
};

ConfirmTenantDialog.defaultProps = {
  buttonCustomClass: '',
};

export default withStyles(styles)(ConfirmTenantDialog);
